
// src/pages/Purchase/Purchase Entry/PurchaseEntry.jsx
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Flex, Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CreatePurchaseForm from "./components/CreatePurchaseForm";
import PurchaseTable from "./components/PurchaseTable";
import { createPurchaseEntry, fetchPurchaseEntryNumber } from "./purchaseThunk";
import { resetPurchaseEntry, setFormField,setTaxAcc,setDiscountAcc } from "./purchaseSlice";
import Swal from "sweetalert2";
import { getAccessType } from "../../../../lib/functions";
import { App } from "antd";
import Big from "big.js";
import { fetchDiscountAccs, fetchTaxAccs } from "../../../../store/commonThunks/lookups";
import { selectAuthInfo } from "../../../Auth/authSelectors";

const PurchaseEntry = ( ) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: convertId } = useParams(); 
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { modal } = App.useApp();

   const authInfo = useSelector(selectAuthInfo);
   const isTatmeenUAE =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates"  && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');
  console.log(authInfo,"authInfoPurchaseEntry");
  
  const { itemCart, supplierInfo, footerValues, payPurchaseCart,selectedTaxAcc,selectedAssetAcc,isTatmeen,sscc_code} = useSelector(
    (s) => s.purchaseEntry
  );

  let [access_type, access_type_set] = useState("");
  
  useEffect(() => {
    const access = getAccessType("purchase_entry");
    access_type_set(access);
  }, []);

  //reset on component unmounting
  useEffect(() => {
    return () => {
      dispatch(resetPurchaseEntry());
    };
  }, [dispatch]);

  // function sanitizePurchaseItems(items) {
  //   return items.filter((row) => {
  //     // Item is mandatory
  //     if (!row.item_id) return false;

  //     // Quantity must be > 0
  //     if (!row.quantity || Number(row.quantity) <= 0) return false;

  //     // Rate must be > 0
  //     if (!row.rate || Number(row.rate) <= 0) return false;

  //     // ✅ Batch & expiry are OPTIONAL
  //     return true;
  //   });
  // }
  
function sanitizePurchaseItems(items) {
  return items.filter((row) => {
    if (!row.item_id) return false;
    if (!row.quantity || Number(row.quantity) <= 0) return false;

    const isBonus =
      row.rate === 0 ||
      row.bounus_update_check === true ||
      row.is_default === true;


    if (!isBonus && (!row.rate || Number(row.rate) <= 0)) return false;

    return true;
  });
}
  function validateDuplicatePurchaseItems(items) {
    const seen = new Set();

    for (const row of items) {
        const isBonus = row.bonus;

    if (isBonus) continue;

      const key = [
        row.item_id,
        (row.batch_name || "").trim().toLowerCase()
      ].join("|");

      if (seen.has(key)) {
        return {
          valid: false,
          message: `Duplicate item with same batch: ${row.product} (${row.batch_name})`,
        };
      }
      seen.add(key);
    }

    return { valid: true };
  }


  // const validateSSCC = () => {
  // // Only validate if Tatmeen is enabled for UAE
  // if (!isTatmeenUAE) return { valid: true };
  // const tatmeenItems = itemCart.filter(item => item.is_tatmeen_required);
  // const nonTatmeenItems = itemCart.filter(item => !item.is_tatmeen_required);
  //  if (tatmeenItems.length === 0) return { valid: true };


  // const parentSSCC = sscc_code?.trim() || "";
  // const childSSCCs = tatmeenItems
  //   .map(item => item.child_sscc_code?.trim() || "")
  //   .filter(code => code !== "");

  // // Check if ANY SSCC is provided (parent or child)
  // const hasParentSSCC = parentSSCC !== "";
  // const hasChildSSCC = childSSCCs.length > 0;

  // // ============================================
  // // RULE 1: If parent SSCC is given, Tatmeen must be enabled
  // // ============================================
  // if (hasParentSSCC && !isTatmeen) {
  //   return {
  //     valid: false,
  //     message: "Parent SSCC Code is provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes.",
  //   };
  // }

  // // ============================================
  // // RULE 2: If child SSCC is given, Tatmeen must be enabled
  // // ============================================
  // if (hasChildSSCC && !isTatmeen) {
  //   return {
  //     valid: false,
  //     message: "Child SSCC Codes are provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes.",
  //   };
  // }

  // // ============================================
  // // RULE 3: If Tatmeen is enabled, ALL items must have batch and child SSCC
  // // ============================================
  // if (isTatmeen) {
  //   // Check parent SSCC
  //   if (!hasParentSSCC) {
  //     return {
  //       valid: false,
  //       message: "Tatmeen is enabled but Parent SSCC Code is missing. Please enter the SSCC Code.",
  //     };
  //   }

  //   // Check each item has batch and child SSCC
  //   const invalidItems = itemCart.filter(item => {
  //     const hasBatch = item.batch_name && item.batch_name.trim() !== "";
  //     const hasChildSSCC = item.child_sscc_code && item.child_sscc_code.trim() !== "";
  //     return !hasBatch || !hasChildSSCC;
  //   });

  //   if (invalidItems.length > 0) {
  //     const itemNames = invalidItems
  //       .map((item, index) => 
  //         `${index + 1}. ${item.product || `Item ID: ${item.item_id}`} - Missing: ${!item.batch_name ? 'Batch' : ''}${!item.batch_name && !item.child_sscc_code ? ' & ' : ''}${!item.child_sscc_code ? 'Child SSCC' : ''}`
  //       )
  //       .join('\n');

  //     return {
  //       valid: false,
  //       message: `Tatmeen is enabled but the following items are missing required fields:\n\n${itemNames}\n\nEach item must have both Batch and Child SSCC Code.`,
  //     };
  //   }

  //   // ============================================
  //   // RULE 4: Child SSCC validation with parent
  //   // ============================================
  //   // Get distinct child SSCC codes
  //   const distinctChildSSCCs = [...new Set(childSSCCs)];

  //   if (distinctChildSSCCs.length === 1) {
  //     // RULE 4a: If all child SSCC are same, parent SSCC should also be the same
  //     const childSSCC = distinctChildSSCCs[0];
  //     if (parentSSCC !== childSSCC) {
  //       return {
  //         valid: false,
  //         message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSSCC}".\n\nParent SSCC must match the Child SSCC when all are the same.`,
  //       };
  //     }
  //   } else if (distinctChildSSCCs.length > 1) {
  //     // ============================================
  //     // RULE 4b: CORRECTED - If child SSCC has distinct count > 1, 
  //     // parent SSCC should NOT match any of them
  //     // ============================================
  //     if (distinctChildSSCCs.includes(parentSSCC)) {
  //       return {
  //         valid: false,
  //         message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSSCC}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`,
  //       };
  //     }
  //   }
  // }

  // return { valid: true };
  // };

  const validateSSCC = () => {
  // Only validate if Tatmeen is enabled for UAE
  if (!isTatmeenUAE) return { valid: true };

  // Get items that have Tatmeen required
  const tatmeenItems = itemCart.filter(item => item.is_tatmeen_required);
  console.log(itemCart,"itemCart1234");
  
  // If no Tatmeen required items, validation passes
  if (tatmeenItems.length === 0) return { valid: true };

  const parentSSCC = sscc_code?.trim() || "";
  const childSSCCs = tatmeenItems
    .map(item => item.child_sscc_code?.trim() || "")
    .filter(code => code !== "");

  // Check if ANY SSCC is provided (parent or child)
  const hasParentSSCC = parentSSCC !== "";
  const hasChildSSCC = childSSCCs.length > 0;

  // ============================================
  // RULE 1: If parent SSCC is given, Tatmeen must be enabled
  // ============================================
  if (hasParentSSCC && !isTatmeen) {
    return {
      valid: false,
      message: "Parent SSCC Code is provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes.",
    };
  }

  // ============================================
  // RULE 2: If child SSCC is given, Tatmeen must be enabled
  // ============================================
  if (hasChildSSCC && !isTatmeen) {
    return {
      valid: false,
      message: "Child SSCC Codes are provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes.",
    };
  }

  // ============================================
  // RULE 3: If Tatmeen is enabled, validate only Tatmeen required items
  // ============================================
  if (isTatmeen) {
    // Check parent SSCC (only if there are Tatmeen required items)
    if (!hasParentSSCC && tatmeenItems.length > 0) {
      return {
        valid: false,
        message: "Tatmeen is enabled and some items have Tatmeen required, but Parent SSCC Code is missing. Please enter the SSCC Code.",
      };
    }

    // Check each Tatmeen required item has batch and child SSCC
    const invalidItems = tatmeenItems.filter(item => {
      const hasBatch = item.batch_name && item.batch_name.trim() !== "";
      const hasChildSSCC = item.child_sscc_code && item.child_sscc_code.trim() !== "";
      return !hasBatch || !hasChildSSCC;
    });

    if (invalidItems.length > 0) {
      const itemNames = invalidItems
        .map((item, index) => 
          `${index + 1}. ${item.product || `Item ID: ${item.item_id}`} - Missing: ${!item.batch_name ? 'Batch' : ''}${!item.batch_name && !item.child_sscc_code ? ' & ' : ''}${!item.child_sscc_code ? 'Child SSCC' : ''}`
        )
        .join('\n');

      return {
        valid: false,
        message: `The following items have Tatmeen enabled but are missing required fields:\n\n${itemNames}\n\nEach Tatmeen required item must have both Batch and Child SSCC Code.`,
      };
    }

    // ============================================
    // RULE 4: Child SSCC validation with parent (only for Tatmeen required items)
    // ============================================
    // Get distinct child SSCC codes from Tatmeen required items
    const distinctChildSSCCs = [...new Set(childSSCCs)];

    if (distinctChildSSCCs.length === 1) {
      // RULE 4a: If all child SSCC are same, parent SSCC should also be the same
      const childSSCC = distinctChildSSCCs[0];
      if (parentSSCC !== childSSCC) {
        return {
          valid: false,
          message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSSCC}".\n\nParent SSCC must match the Child SSCC when all are the same.`,
        };
      }
    } else if (distinctChildSSCCs.length > 1) {
      // RULE 4b: If child SSCC has distinct count > 1, 
      // parent SSCC should NOT match any of them
      if (distinctChildSSCCs.includes(parentSSCC)) {
        return {
          valid: false,
          message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSSCC}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`,
        };
      }
    }
  }

  return { valid: true };
};


  // ============================================
  // 🚀 Serial Validation for Tatmeen (UPDATED with cross-item check)
  // ============================================
  // const validateSerialsForTatmeen = () => {
  //   if (!isTatmeenUAE || !isTatmeen) return { valid: true };

  //   // Collect all serials from all items for cross-check
  //   const allSerials = [];
  //   const serialToItemMap = {};

  //   for (const row of itemCart) {
  //     if (row.is_serial === "yes") {
  //       const serials = row.serials || [];
  //       const requiredCount = row.serial_mode === "batch" ? 1 : Number(row.quantity) || 0;

  //       // Check count per item
  //       if (serials.length !== requiredCount) {
  //         return {
  //           valid: false,
  //           message: row.serial_mode === "batch"
  //             ? `${row.product} requires 1 serial for the batch (Tatmeen enabled)`
  //             : `${row.product} requires ${requiredCount} serial number${requiredCount > 1 ? 's' : ''} (Tatmeen enabled)`,
  //         };
  //       }

  //       // Check duplicates within same item
  //       const duplicateWithinItem = serials.filter(
  //         (s, index) => serials.indexOf(s) !== index
  //       );

  //       if (duplicateWithinItem.length > 0) {
  //         return {
  //           valid: false,
  //           message: `${row.product} contains duplicate serial numbers within the same item: ${duplicateWithinItem.join(', ')}`,
  //         };
  //       }

  //       // Store serials for cross-item validation
  //       serials.forEach(serial => {
  //         if (serial && serial.trim()) {
  //           const trimmedSerial = serial.trim();
  //           allSerials.push(trimmedSerial);
  //           serialToItemMap[trimmedSerial] = row.product;
  //         }
  //       });
  //     }
  //   }

  //   // ============================================
  //   // 🚀 NEW: Cross-Item Serial Validation
  //   // Check if any serial number appears in more than one item
  //   // ============================================
  //   const serialCount = {};
  //   allSerials.forEach(serial => {
  //     serialCount[serial] = (serialCount[serial] || 0) + 1;
  //   });

  //   const duplicateSerials = Object.keys(serialCount).filter(
  //     serial => serialCount[serial] > 1
  //   );

  //   if (duplicateSerials.length > 0) {
  //     const duplicateDetails = duplicateSerials.map(serial => {
  //       // Find which items have this serial
  //       const itemsWithSerial = itemCart
  //         .filter(row => {
  //           const serials = row.serials || [];
  //           return serials.some(s => s && s.trim() === serial);
  //         })
  //         .map(row => row.product)
  //         .join(', ');
        
  //       return `Serial "${serial}" appears in: ${itemsWithSerial}`;
  //     }).join('\n');

  //     return {
  //       valid: false,
  //       message: `Duplicate serial numbers found across different items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all items.`,
  //     };
  //   }

  //   return { valid: true };
  // };
  
  const validateSerialsForTatmeen = () => {
  if (!isTatmeenUAE) return { valid: true };

  // Get items that have Tatmeen required
  const tatmeenItems = itemCart.filter(item => item.is_tatmeen_required);
  
  // If no Tatmeen required items, validation passes
  if (tatmeenItems.length === 0) return { valid: true };

  // Validate serials only for Tatmeen required items
  for (const row of tatmeenItems) {
    const serials = row.serials || [];
    const requiredCount = row.serial_mode === "batch" ? 1 : Number(row.quantity) || 0;

    // Check count per item
    if (serials.length !== requiredCount) {
      return {
        valid: false,
        message: row.serial_mode === "batch"
          ? `${row.product} requires 1 serial for the batch (Tatmeen enabled)`
          : `${row.product} requires ${requiredCount} serial number${requiredCount > 1 ? 's' : ''} (Tatmeen enabled)`,
      };
    }

    // Check duplicates within same item
    const duplicateWithinItem = serials.filter(
      (s, index) => serials.indexOf(s) !== index
    );

    if (duplicateWithinItem.length > 0) {
      return {
        valid: false,
        message: `${row.product} contains duplicate serial numbers within the same item: ${duplicateWithinItem.join(', ')}`,
      };
    }
  }

  // Cross-item duplicate validation only for Tatmeen required items
  const allSerials = [];
  const serialToItemMap = {};

  tatmeenItems.forEach(row => {
    const serials = row.serials || [];
    serials.forEach(serial => {
      if (serial && serial.trim()) {
        const trimmedSerial = serial.trim();
        allSerials.push(trimmedSerial);
        serialToItemMap[trimmedSerial] = row.product;
      }
    });
  });

  const serialCount = {};
  allSerials.forEach(serial => {
    serialCount[serial] = (serialCount[serial] || 0) + 1;
  });

  const duplicateSerials = Object.keys(serialCount).filter(
    serial => serialCount[serial] > 1
  );

  if (duplicateSerials.length > 0) {
    const duplicateDetails = duplicateSerials.map(serial => {
      const itemsWithSerial = tatmeenItems
        .filter(row => {
          const serials = row.serials || [];
          return serials.some(s => s && s.trim() === serial);
        })
        .map(row => row.product)
        .join(', ');
      
      return `Serial "${serial}" appears in: ${itemsWithSerial}`;
    }).join('\n');

    return {
      valid: false,
      message: `Duplicate serial numbers found across different items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all items.`,
    };
  }

  return { valid: true };
};

  const handleSave = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    const mode = segments[1];
    const editId = segments[2] || null;

     const ssccValidation = validateSSCC();
    if (!ssccValidation.valid) {
      Swal.fire({
        title: "SSCC Validation Error",
        html: ssccValidation.message.replace(/\n/g, '<br>'),
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }
    
    const cleanedItems = sanitizePurchaseItems(itemCart);
  
    if (cleanedItems.length === 0) {
      Swal.fire(
        "Invalid Purchase Entry",
        "Please add at least one item with quantity.",
        "warning"
      );
      return;
    }

    const { valid, message } = validateDuplicatePurchaseItems(cleanedItems);

    if (!valid) {
      Swal.fire("Duplicate Item", message, "warning");
      return;
    }

    const serialValidation = validateSerialsForTatmeen();
    if (!serialValidation.valid) {
      Swal.fire({
        title: "Serial Validation Error",
        html: serialValidation.message.replace(/\n/g, '<br>'),
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    dispatch(
      setFormField({
        field: "itemCart",
        value: cleanedItems,
      })
    );

    

    const payCartTotal = Array.isArray(payPurchaseCart)
      ? payPurchaseCart.reduce(
          (sum, p) => sum.plus(p.tran_amount || 0),
          new Big(0)
        )
      : new Big(0);

    const grandTotal = parseFloat(footerValues?.grandTotal) || 0;
    const paidAmount = Number(footerValues?.paidAmount || 0);

    const payCart = Array.isArray(payPurchaseCart) ? payPurchaseCart : [];

    const cartPaidAmount = payCart
    .filter((item) => item.acc_type_id !== "cheque")
    .reduce((sum, item) => sum.plus(item.tran_amount || 0), new Big(0));

    const cartTotal = payCart.reduce(
      (sum, item) => sum.plus(item.tran_amount || 0),
      new Big(0)
    );

    const hasConversionRate = Number(footerValues?.conversion_rate) > 0;

    const grandTotalBig = new Big(footerValues?.grandTotal || 0);

    const maxAllowedCartTotal = hasConversionRate
    ? grandTotalBig.plus(0.1)
    : grandTotalBig;

    if (!itemCart || itemCart.length === 0) {
      Swal.fire("Item cart is Empty!", "", "warning");
      return;
    }

    if (!supplierInfo || !supplierInfo.acc_id) {
      Swal.fire("Select supplier!", "", "warning");
      return;
    }

    if (footerValues?.description && footerValues.description.length > 255) {
      Swal.fire("Description max size exceeded", "", "warning");
      return;
    }

    if (itemCart[0].item_id === null) {
      Swal.fire("Please add atleast one item!");
      return;
    }

    if (itemCart[0].quantity === 0 || null) {
      Swal.fire("Please add quantity!");
      return;
    }

    if (!cartPaidAmount.eq(paidAmount)) {
      modal.warning({
        title: "Paid Amount & Payment Cart Amount Should be Same !",
        content: "",
      });
      return;
    }

    const cartTotalRounded = cartTotal.round(2);
    const grandTotalRounded = grandTotalBig.round(2);

    if (cartTotalRounded.gt(grandTotalRounded)) {
      modal.warning({
        title: "Payment amount exceeds total!",
        content: `Cart Total (${cartTotal.toFixed(
          2
        )}) should not exceed Grand Total (${grandTotal.toFixed(2)})`,
      });
      return;
    }

    const hasVatItems = cleanedItems.some(item => Number(item.tax_per) > 0);
const hasTaxAcc = selectedTaxAcc?.acc_id;

if (hasVatItems && !hasTaxAcc) {
  Swal.fire(
    "Tax Account Required",
    "Please refresh your page before adding next purchase",
    "warning"
  );
  return;
}

const hasAssetItems = cleanedItems.some(item => item.is_asset);
const hasAssetAcc = selectedAssetAcc?.acc_id;

if (hasAssetItems && !hasAssetAcc) {
  Swal.fire(
    "Asset Account Required",
    "Please select an Asset Account for the asset line(s) on this bill.",
    "warning"
  );
  return;
}

    Swal.fire({
      title: mode === "edit"
        ? "Updating Purchase Entry..."
        : "Saving Purchase Entry...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

dispatch(createPurchaseEntry({ orderId: convertId || 0 }))
      .unwrap()
      .then((res) => {
        Swal.close();

        if (res?.error) {
          Swal.fire(res.message || "Something went wrong", "", "warning");
          return;
        }

        // 🔥 EDIT MODE
        if (mode === "edit" && editId) {
          Swal.fire({
            title: "Purchase Entry Updated Successfully!",
            icon: "success",
          }).then(() => {
            dispatch(resetPurchaseEntry());
            navigate("/purchase", { replace: true });
          });
          return;
        }

        // 🔥 CREATE MODE
        dispatch(resetPurchaseEntry());
        dispatch(fetchPurchaseEntryNumber());

        Swal.fire({
          title: `Purchase Entry Created! Do you want to view invoice?`,
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Yes, view invoice",
          cancelButtonText: "No, go back",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/purchase/quick-purchase-voucher/${res.pur_id}`);
          } else {
            navigate("/purchase", { replace: true });
          }
        });
      })
      .catch((err) => {
        Swal.close();
        Swal.fire(err || "Network ERROR", "", "error");
      });
  };

  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate(-1);
    }
  };

  const handleReset = () => {
    dispatch(resetPurchaseEntry());
    Swal.fire("Form Reset", "All fields and items cleared", "info");
    dispatch(fetchPurchaseEntryNumber());
  
  };

  const ActionButtons = () => (
    <Flex justify="flex-end" gap={16} style={{ marginBottom: 16 }}>
      <Button onClick={handleBack}>Back</Button>
      <Button onClick={handleReset}>Reset</Button>
      {access_type == "WRITE" && (
        <>
          <Button
            type="primary"
            onClick={handleSave}
            data-testid="final-save-btn"
          >
            Save
          </Button>
        </>
      )}
    </Flex>
  );

  return (
    <div style={{ padding: 20 }}>
      {!screens.xs && (
        <Row>
          <Col span={24}>
            <ActionButtons />
          </Col>
        </Row>
      )}

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CreatePurchaseForm convertId={convertId} />
        </Col>
        <Col span={24}>
          <PurchaseTable authInfo={authInfo} convertId={convertId} />
        </Col>
      </Row>

      <Row style={{ marginTop: 24 }}>
        <Col span={24}>
          <ActionButtons />
        </Col>
      </Row>
    </div>
  );
};

export default PurchaseEntry;

// // src/pages/Purchase/Purchase Entry/PurchaseEntry.jsx
// import React, { useEffect, useState } from "react";
// import { Row, Col, Button, Flex, Grid } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import CreatePurchaseForm from "./components/CreatePurchaseForm";
// import PurchaseTable from "./components/PurchaseTable";
// import { createPurchaseEntry, fetchPurchaseEntryNumber } from "./purchaseThunk";
// import { resetPurchaseEntry, setFormField } from "./purchaseSlice";
// import Swal from "sweetalert2";
// import { getAccessType } from "../../../../lib/functions";
// import { App } from "antd";

// const PurchaseEntry = ({ authInfo }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { useBreakpoint } = Grid;
//   const screens = useBreakpoint();
//   const { modal } = App.useApp();

//   const { itemCart, supplierInfo, footerValues, payPurchaseCart } = useSelector(
//     (s) => s.purchaseEntry
//   );

//   let [access_type, access_type_set] = useState("");
  
//   useEffect(() => {
//     const access = getAccessType("purchase_entry");
//     access_type_set(access);
//   }, []);

//   //reset on component unmounting
//   useEffect(() => {
//     return () => {
//       dispatch(resetPurchaseEntry());
//     };
//   }, [dispatch]);

  


//   function sanitizePurchaseItems(items) {
//     return items.filter((row) => {
//       // Item is mandatory
//       if (!row.item_id) return false;

//       // Quantity must be > 0
//       if (!row.quantity || Number(row.quantity) <= 0) return false;

//       // Rate must be > 0
//       if (!row.rate || Number(row.rate) <= 0) return false;

//       // ✅ Batch & expiry are OPTIONAL
//       return true;
//     });
//   }



//     function validateDuplicatePurchaseItems(items) {
//       const seen = new Set();

//       for (const row of items) {
//         const key = [
//           row.item_id,
//           (row.batch_name || "").trim().toLowerCase()
//         ].join("|");

//         if (seen.has(key)) {
//           return {
//             valid: false,
//             message: `Duplicate item with same batch: ${row.product} (${row.batch_name})`,
//           };
//         }
//         seen.add(key);
//       }

//       return { valid: true };
//     }


//   const handleSave = () => {

//     const segments = location.pathname.split("/").filter(Boolean);
//     const mode = segments[1];
//     const editId = segments[2] || null;

//     const cleanedItems = sanitizePurchaseItems(itemCart);
//     // const cleanedItems = itemCart;
        
//     if (cleanedItems.length === 0) {
//       Swal.fire(
//         "Invalid Purchase Entry",
//         "Please add at least one item with quantity.",
//         "warning"
//       );
//       return;
//     }

//     const { valid, message } =
//       validateDuplicatePurchaseItems(cleanedItems);

//     if (!valid) {
//       Swal.fire("Duplicate Item", message, "warning");
//       return;
//     }

//       dispatch(
//       setFormField({
//         field: "itemCart",
//         value: cleanedItems,
//       })
//     );


//     const payCartTotal = Array.isArray(payPurchaseCart)
//       ? payPurchaseCart.reduce(
//           (sum, p) => sum + (parseFloat(p.tran_amount) || 0),
//           0
//         )
//       : 0;

//     // ✅ Parse grand total safely
//     const grandTotal = parseFloat(footerValues?.grandTotal) || 0;
//   const paidAmount = Number(footerValues?.paidAmount || 0);

//     const payCart = Array.isArray(payPurchaseCart)
//       ? payPurchaseCart
//       : [];

//     const cartPaidAmount = payCart
//       .filter((item) => item.acc_type_id !== "cheque") // 👈 exclude cheques
//       .reduce((sum, item) => sum + parseFloat(item.tran_amount || 0), 0);

//     const cartTotal = payCart.reduce(
//       (sum, item) => sum + Number(item.tran_amount || 0),
//       0
//     );

//     const hasConversionRate = Number(footerValues?.conversion_rate) > 0;

//     const maxAllowedCartTotal = hasConversionRate
//       ? grandTotal + 0.1
//       : grandTotal;

    
      
      

//     if (!itemCart || itemCart.length === 0) {
//       Swal.fire("Item cart is Empty!", "", "warning");
//       return;
//     }



//     if (!supplierInfo || !supplierInfo.acc_id) {
//       Swal.fire("Select supplier!", "", "warning");
//       return;
//     }
//     if (footerValues?.description && footerValues.description.length > 255) {
//       Swal.fire("Description max size exceeded", "", "warning");
//       return;
//     }
//     if (itemCart[0].item_id === null) {
//       Swal.fire("Please add atleast one item!");
//       return;
//     }
//     if (itemCart[0].quantity === 0 || null) {
//       Swal.fire("Please add quantity!");
//       return;
//     }

//     // if (creditLimit < totalDueAmount && dueAmount !== 0) {
//     //   modal.warning({
//     //     title: "Credit Limit is Over of Customer!",
//     //     content: (
//     //       <>
//     //         <p>Total Credit Limit: {creditLimit.toFixed(2)}</p>
//     //         <p>Used / Required Amount: {totalDueAmount.toFixed(2)}</p>
//     //         <p>
//     //           Available Credit:{" "}
//     //           <strong style={{ color: "red" }}>
//     //             {availableCredit.toFixed(2)}
//     //           </strong>
//     //         </p>
//     //       </>
//     //     ),
//     //   });
//     //   return;
//     // }

//     // ✅ Validation: payServiceCart total should not exceed grand total
//     // if (payCartTotal > grandTotal) {
//     //   Swal.fire(
//     //     "Invalid Payment!",
//     //     "Total pay service charges cannot exceed the grand total amount.",
//     //     "warning"
//     //   );
//     //   return;
//     // }

//     if (paidAmount !== cartPaidAmount) {
//       modal.warning({
//         title: "Paid Amount & Payment Cart Amount Should be Same !",
//         content: "",
//       });
//       return;
//     }

//     if (cartTotal > maxAllowedCartTotal) {
//       modal.warning({
//         title: "Payment amount exceeds total!",
//         content: `Cart Total (${cartTotal.toFixed(
//           2
//         )}) should not exceed Grand Total (${grandTotal.toFixed(2)})`,
//       });
//       return;
//     }

     
//     Swal.fire({
//       title: mode === "edit"
//         ? "Updating Purchase Entry..."
//         : "Saving Purchase Entry...",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     dispatch(createPurchaseEntry())
//       .unwrap()
//       .then((res) => {
//         Swal.close();

//         if (res?.error) {
//         Swal.fire(res.message || "Something went wrong", "", "warning");
//         return;
//       }
//           // 🔥 EDIT MODE
//       if (mode === "edit" && editId) {
//         Swal.fire({
//           title: "Purchase Entry Updated Successfully!",
//           icon: "success",
//         }).then(() => {
//           dispatch(resetPurchaseEntry());
//           navigate("/purchase", { replace: true }); // remove edit id
//         });
//         return;
//       }

//       // 🔥 CREATE MODE
//       dispatch(resetPurchaseEntry());
//       dispatch(fetchPurchaseEntryNumber());

//           Swal.fire({
//             title: `Purchase Entry Created! Do you want to view invoice?`,
//             icon: "success",
//             showCancelButton: true,
//             confirmButtonText: "Yes, view invoice",
//             cancelButtonText: "No, go back",
//           }).then((result) => {
//             // dispatch(resetPurchaseEntry());
//             if (result.isConfirmed) {
//               navigate(`/purchase/quick-purchase-voucher/${res.pur_id}`);
//             } else {
//               navigate("/purchase", { replace: true });
//             }
//           });
        
//       })
//       .catch((err) => {
//         Swal.close();
//         Swal.fire(err || "Network ERROR", "", "error");
//       });
//   };

//   const handleBack = () => {
//     if (location.state?.from) {
//       navigate(location.state.from);
//     } else {
//       navigate(-1);
//     }
//   };

//   const handleReset = () => {
//     dispatch(resetPurchaseEntry());
//     Swal.fire("Form Reset", "All fields and items cleared", "info");
//     dispatch(fetchPurchaseEntryNumber());
//   };

//   const ActionButtons = () => (
//     <Flex justify="flex-end" gap={16} style={{ marginBottom: 16 }}>
//       <Button onClick={handleBack}>Back</Button>
//       <Button onClick={handleReset}>Reset</Button>
//       {access_type == "WRITE" && (
//         <>
//           <Button
//             type="primary"
//             onClick={handleSave}
//             data-testid="final-save-btn"
//           >
//             Save
//           </Button>
//         </>
//       )}
//     </Flex>
//   );

//   return (
//     <div style={{ padding: 20 }}>
//       {!screens.xs && (
//         <Row>
//           <Col span={24}>
//             <ActionButtons />
//           </Col>
//         </Row>
//       )}

//       <Row gutter={[16, 16]}>
//         <Col span={24}>
//           <CreatePurchaseForm authInfo={authInfo} />
//         </Col>
//         <Col span={24}>
//           <PurchaseTable authInfo={authInfo} />
//         </Col>
//       </Row>

//       <Row style={{ marginTop: 24 }}>
//         <Col span={24}>
//           <ActionButtons />
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default PurchaseEntry;